import { render, staticRenderFns } from "./Oauth2Callback.vue?vue&type=template&id=18413180&"
import script from "./Oauth2Callback.vue?vue&type=script&lang=js&"
export * from "./Oauth2Callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports